var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9282_23509)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9934 0.737176L3.32678 0.737284C2.79635 0.73729 2.28764 0.948009 1.91256 1.32309C1.53748 1.69816 1.32676 2.20687 1.32676 2.7373L1.32662 13.404C1.32661 13.9344 1.53732 14.4431 1.91238 14.8182C2.28745 15.1932 2.79616 15.404 3.32659 15.404L13.9933 15.4038C14.5237 15.4038 15.0324 15.1931 15.4075 14.818C15.7826 14.443 15.9933 13.9343 15.9933 13.4038L15.9934 2.73716C15.9934 2.20672 15.7827 1.69802 15.4077 1.32295C15.0326 0.947879 14.5239 0.73717 13.9934 0.737176ZM3.32676 2.07062L13.9934 2.07051C14.1702 2.07051 14.3398 2.14074 14.4648 2.26577C14.5899 2.39079 14.6601 2.56036 14.6601 2.73717L14.6601 5.40384L2.66005 5.40396L2.66009 2.73729C2.66009 2.56048 2.73033 2.39091 2.85536 2.26588C2.98038 2.14086 3.14995 2.07062 3.32676 2.07062ZM2.85521 13.8754C2.98023 14.0004 3.1498 14.0706 3.32661 14.0706L5.76595 14.0706L5.76605 6.73726L2.66004 6.73729L2.65995 13.404C2.65995 13.5808 2.73018 13.7503 2.85521 13.8754ZM7.09938 6.73725L7.09928 14.0706L10.2184 14.0705L10.2185 6.73721L7.09938 6.73725ZM14.66 13.4038L14.66 6.73717L11.5518 6.7372L11.5517 14.0705L13.9933 14.0705C14.1701 14.0705 14.3397 14.0003 14.4647 13.8752C14.5897 13.7502 14.6599 13.5806 14.66 13.4038Z",
    fill: "#4C545B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9282_23509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(1 -1.01771e-05 -1.30761e-05 1 0.660156 0.0708008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardView);
export default __webpack_public_path__ + "static/media/cardView.f7a4f3c98bd027437127ef834e003fc8.svg";
export { ForwardRef as ReactComponent };